import * as echarts from 'echarts';
import html2canvas from 'html2canvas';

import utils from './utils';
import graphics from './graphics';

class Charts {
    initCharts(container) {
        $('.chart', container).filter(':visible').each((index, node) => {
            let id = $(node).attr('id');
            let options = window['options_' + id];
            let chart = echarts.init(document.getElementById(id));

            chart.on('finished', () => {
                $(node).trigger('echarts.finished', [chart]);
            });

            chart.setOption(options);

            $(window).on('resize', function() {
                chart.resize();
            });

            /*
                Used to interactively display different datas when a chart is
                zoomed. Zoomable widgets have to provide the JS alt_options_*
                variable into the page, from which retrieve the alternative data
            */
            chart.on('dataZoom', function(params) {
                var start = params.start;
                var end = params.end;
                let options = window['options_' + id];

                if (end - start < 50) {
                    options = window['alt_options_' + id];
                }

                chart.setOption({
                    xAxis: options.xAxis,
                    yAxis: options.yAxis,
                    series: options.series,
                });
            });
        });

        $('.tab-saver', container).click((e) => {
            e.preventDefault();

            let div = $(e.currentTarget).closest('.card').find('.tab-content .tab-pane.active').get(0);

            html2canvas(div).then((canvas) => {
                canvas.style.display = 'none'
                document.body.appendChild(canvas);

                const image = canvas.toDataURL('image/png');
                const a = document.createElement('a');
                a.setAttribute('download', 'echarts.png');
                a.setAttribute('href', image);
                a.click();

                canvas.remove();
            })
        });
    }
}

export default Charts;
